import React, { Component, Fragment } from 'react';
import { InputGroup, Input, Col, Label } from 'reactstrap';
import i18n from '../../../../i18next';
import moment from 'moment';
import { tz } from 'moment-timezone';

class SnoozeInputs extends Component {
    constructor() {
        super();

        this.state = {
            error: false,
            snooze: '',
            customDate: i18n.t('screens:productScreen.snoozeCustom')
        };
    }

    changeSnooze({ target }) {
        this.setState({
            ...this.state,
            snooze: target.value
        }, () => this.props.changeSnoozeTime(target.value));
    }

    getMinutesFromDate(e) {
        const now = moment().format('YYYY-MM-DD HH:mm Z');
        const targetDate = moment(`${e.target.value} 23:59`).format('YYYY-MM-DD HH:mm Z');

        if (moment(targetDate, 'YYYY-MM-DD HH:mm').isBefore(now, 'YYYY-MM-DD HH:mm')) {

            this.setState({
                error: true
            }, () => this.props.changeSnoozeTime(''));
        } else {

            this.setState({
                error: false
            });

            let newZone = tz(`${e.target.value} 23:59:59`, this.props.restaurant.timeZone).format();
            let dateDiff = Date.parse(`${newZone}`) - Date.now();
            let dateDiffInMinutes = Math.abs(Math.floor(dateDiff / 60000));

            this.props.changeSnoozeTime(dateDiffInMinutes);
        }
    };

    render() {
        const { mainCol, inputGroup, inputLabel, inputStyle, secondCol, timeText, snoozeTime, paragraphs, warningMsg } = styles;
        const { inactiveUntilTime } = this.props.currentProduct;

        return (
            <Fragment>
                <Col sm={12} style={mainCol}>
                    <InputGroup style={inputGroup} hidden={this.props.posSettings.type.id === 7}>
                        <Label style={inputLabel}>{i18n.t('screens:productScreen.snoozeProduct')}</Label>
                        <Input
                            id='snoozingProducts'
                            type='select'
                            name='snoozing'
                            required
                            onChange={this.changeSnooze.bind(this)}
                            value={this.state.snooze}
                            style={inputStyle}
                        >
                            <option value={''}>{i18n.t('screens:productScreen.unlimited')}</option>
                            <option value={60 * 24}>1 {i18n.t('screens:productScreen.snoozeDay')}</option>
                            <option value={60 * 6}>6 {i18n.t('screens:productScreen.snoozeHours')}</option>
                            <option value={60 * 3}>3 {i18n.t('screens:productScreen.snoozeHours')}</option>
                            <option value={60}>1 {i18n.t('screens:productScreen.snoozeHour')}</option>
                            <option value={30}>30 {i18n.t('screens:productScreen.snoozeMins')}</option>
                            <option value={'custom'}>{i18n.t('screens:productScreen.snoozeCustom')}</option>
                        </Input>
                    </InputGroup>
                    <div style={secondCol}>
                        <div style={timeText}>{i18n.t('screens:productScreen.snoozeUntil')}:</div>
                        <div style={snoozeTime}>
                            {
                                this.props.posSettings.type.id === 7 && !inactiveUntilTime ?
                                    <p style={paragraphs}>{i18n.t('screens:productScreen.unlimited')}</p> :
                                    <p style={paragraphs}>{inactiveUntilTime}</p>
                            }
                        </div>
                    </div>
                </Col>
                {
                    this.state.snooze === 'custom' &&
                    <Col sm={6} style={{ paddingRight: 25 }}>
                        <InputGroup>
                            <Input
                                type='date'
                                name='snoozing'
                                min={moment().format('YYYY-MM-DD')}
                                required
                                onChange={(e) => this.getMinutesFromDate(e)}
                            />
                        </InputGroup>
                    </Col>
                }
                <Col sm={12} style={{ paddingLeft: 0 }}>
                    <p style={warningMsg}>*{this.state.error ? i18n.t('screens:productScreen.validationMsg') : i18n.t('screens:productScreen.warningMsg')}</p>
                </Col>
            </Fragment>
        );
    }
}

export default SnoozeInputs;

const styles = {
    mainCol: { display: 'flex' },
    inputGroup: { display: 'flex', width: '50%' },
    inputLabel: { display: 'flex', alignSelf: 'center', marginRight: 10 },
    inputStyle: { display: 'flex', width: 160, maxWidth: 160 },
    secondCol: { display: 'flex', width: '50%', paddingLeft: 25, flexWrap: 'wrap' },
    timeText: { display: 'flex', alignSelf: 'center', marginRight: 10, marginBottom: 8 },
    snoozeTime: { display: 'flex', alignSelf: 'center', minHeight: 50, minWidth: 100 },
    paragraphs: { marginBottom: 8, display: 'flex', alignSelf: 'center' },
    warningMsg: { color: 'red', fontSize: 14, paddingLeft: 12 }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/SnoozeInputs.js